import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import CheckboxField from './CheckboxField'
import Value from '../Value'
import DateCalendarField from './DateCalendarField'
import * as validations from '../../../utils/validations'
import SelectField from './SelectField'
import { useField } from 'react-final-form'
import useFieldValue from '../../../hooks/useFieldValue'
import Alert from '../Alert'
import WhenFieldChanges from '../WhenFieldChanges'
import { hourFormattedByNumber } from '../../../utils/helpers'

const nameByKind = {
  publish: 'publicación',
  unpublish: 'despublicación'
}

const generateHourOptions = minHour => {
  return Array.from({ length: 24 - minHour }, (_, index) => {
    const formattedHour = hourFormattedByNumber(index + minHour)
    return { value: formattedHour, label: formattedHour }
  })
}

const PublishScheduleField = ({
  kind,
  minimumDate,
  minHour = 0,
  notifyComplete,
  datePlaceholder,
  onHourChange,
  onDateChange,
  onCheckChange
}) => {
  const { input: destroyInput } = useField(`${kind}._destroy`)
  const checkValue = useFieldValue(`${kind}.value`)
  const checkDateValue = useFieldValue(`${kind}.date`)
  const options = useMemo(() => generateHourOptions(minHour), [minHour])

  useEffect(() => {
    if (checkValue) {
      destroyInput.onChange(undefined)
    } else {
      destroyInput.onChange(true)
    }
  }, [checkValue, destroyInput])

  return (
    <div>
      <CheckboxField
        name={`${kind}.value`}
        margin="none"
        label={`Fecha y hora de ${nameByKind[kind]}`}
        onChange={onCheckChange}
      />
      <Value name={`${kind}.value`}>
        {({ value: scheduleValue }) =>
          scheduleValue && (
            <div className="flex flex-col md:flex-row md:gap-4 md:items-start gap-2 mt-2 justify-between">
              <div className="flex md:flex-row flex-col md:gap-4 gap-2 md:w-130 md:min-w-130">
                <DateCalendarField
                  name={`${kind}.date`}
                  minimumDate={minimumDate}
                  validate={validations.mix(validations.required(), validations.isDate())}
                  size="xl"
                  placeholder={datePlaceholder}
                  onChange={onDateChange}
                  className="min-w-60"
                />
                <SelectField
                  name={`${kind}.hour`}
                  options={checkDateValue ? options : []}
                  validate={validations.required()}
                  size="w-60"
                  emptyLabel="Selecciona una hora"
                  className="min-w-60 max-h-12"
                  onChange={onHourChange}
                />
              </div>
              {notifyComplete && (
                <Alert type="info" className="md:mb-0 mb-4 max-w-160 font-normal" border>
                  Deberás subir la Política de Privacidad en el formulario, antes de la fecha de publicación programada,
                  caso contrario, <span className="font-extrabold">NO se realizará la publicación.</span>
                </Alert>
              )}
              <WhenFieldChanges field={`${kind}.date`} set={`${kind}.hour`} to={null} condition={value => !value} />
            </div>
          )
        }
      </Value>
    </div>
  )
}

export default PublishScheduleField

PublishScheduleField.propTypes = {
  kind: PropTypes.oneOf(['publish', 'unpublish']),
  minimumDate: PropTypes.object,
  minHour: PropTypes.number,
  notifyComplete: PropTypes.bool,
  datePlaceholder: PropTypes.string,
  onHourChange: PropTypes.func,
  onDateChange: PropTypes.func,
  onCheckChange: PropTypes.func
}
